import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = sessionStorage.getItem('token');
    const storedUser = sessionStorage.getItem('user');

    if (storedToken) {
      setToken(storedToken);
      if (storedUser && storedUser !== 'undefined') {
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Failed to parse user from sessionStorage:', error);
          sessionStorage.removeItem('user');
          setUser(null);
          setIsAuthenticated(false);
        }
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
      setUser(null);
      sessionStorage.removeItem('user');
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    sessionStorage.setItem('token', token);
    if (userData && typeof userData !== 'undefined') {
      const userToStore = {
        email: userData.email || '',
        role: userData.role ? userData.role.toUpperCase() : 'EMPLOYEE',
        name: userData.name || 'User',
        department: userData.department || '',
        employeeId: userData.employeeId || null,
        jobTitle: userData.jobTitle || '',
      };
      if (!['EMPLOYEE', 'CONSULTANT', 'ADMIN', 'FINANCIAL_ADMIN', 'INTERN', 'MANAGER'].includes(userToStore.role)) {
        console.warn(`Unexpected role value: ${userData.role}. Defaulting to EMPLOYEE.`);
        userToStore.role = 'EMPLOYEE';
      }
      sessionStorage.setItem('user', JSON.stringify(userToStore));
      setUser(userToStore);
      setToken(token);
      setIsAuthenticated(true);
    } else {
      sessionStorage.removeItem('user');
      setUser(null);
      setToken(token);
      setIsAuthenticated(true);
    }
  };

  const logout = () => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    setToken(null);
    setUser(null);
    setIsAuthenticated(false);
    navigate('/login');
  };

  const handleTokenExpiry = () => {
    logout();
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        loading,
        token,
        user,
        login,
        logout,
        handleTokenExpiry,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};